<template>
  <app-industry-profile-template class="app-industry-profile-template-telecom"
          title="Are you tired of the 2-3% monthly churn<span>?</span>"
          industryName="Telecom"
          :brands="brands">

    <p><strong>Are you tired of the 2-3% monthly churn?</strong></p>

    <p>
      That is over a third of your customers – every year. Too many of your customers are simply not loyal.
      They shop around, they change their phone company for 5 euros in savings – and you are losing revenue.<br><br>

      <strong>The let`s change the game:</strong><br><br>

      Why don’t you reward your customers for doing business with you? Now, before you think “we don’t have enough
      margins to even contemplate a rewards program”, let us give you an idea – get someone else to pay for the rewards!
    </p>

    <p>
      <strong>Learn how</strong><br>
    </p>

    <img v-on:keyup.enter="videoThumbnailOnClick"
         v-on:click.prevent="videoThumbnailOnClick"
         src="@/assets/images/video-thumbnails/telecom.jpg" alt="Telecom video image" tabindex="0">

    <br>
    <br>

    <p class="no-margin">
      <strong>Telecom loyalty reimagined.</strong><br><br>

      We have the experience, know-how, and technology.
    </p>

    <div id="telecom-video" class="wistia_embed popover=true wistia_async_q3my49pv75" style="visibility: hidden; height: 0;">&nbsp;</div>
  </app-industry-profile-template>
</template>

<script>
  import AppIndustryProfileTemplate from '@/components/layout/templates/view/AppViewTemplateIndustryProfile';

  export default {
    name: 'TelecomProfile',

    components: {
      AppIndustryProfileTemplate
    },

    data: function() {
      return {
        brands: {
          title: '',
          items: [
            {
              label: 'Our solution can reduce your customer churn',
            },
          ],
        },
      }
    },

    methods: {
      videoThumbnailOnClick() {
        window.wistiaInit = function(W) {
          let video = W.api("telecom-video");

          video.play();

          video.bind("popovershow", function() {
            //console.log("The popover for ", video.hashedId(), " is visible!");
          });

          video.bind("popoverhide", function() {
            //console.log("The popover for ", video.hashedId(), " is hidden!");
          });
        };
      },

    },

    beforeDestroy() {
      document.getElementById('telecom-video_popover_container').remove();
    }
  }
</script>

<style lang="scss">
  .app-industry-profile-template-telecom {
    min-height: calc(100vh - 100px);

    @media (min-width: $lgBreakpoint) {
      .banners {
        background-image: url("../../../assets/images/industries/banners/telecom.jpg");
      }
    }

    img {
      max-width: 100%;
      display: block;
      cursor: pointer;

      &:hover, &:focus {
        opacity: 0.7;
      }
    }
  }
</style>
